<split-view>
  <div left>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 mt-3">
          <div class="nc-section-icon fas fa-info-circle"></div>
          <h1 class="nc-section-header">Tell us about {{accountName}}</h1>
          <p class="top-buffer">Help us serve you better by telling us more.</p>
        </div>
      </div>
    </div>
  </div>

  <div right>
    <div class="container-fluid big-top-buffer">
      <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
        <div formGroupName="accountProfile">
          <div class="row">
            <div class="col-sm-12">
              <fieldset class="form-group">
                <h4 class="top-buffer tiny-bottom-buffer">
                  Who is the primary user for this account?
                </h4>
                <p class="small text-muted bottom-buffer">
                  The primary user is who will most regularly use Verblio to get content. You may add other users later.
                </p>
                <label for="contact-name">
                  Name <span class="text-danger">*</span>
                </label>
                <input class="form-control" type="text" id="contact-name" formControlName="contactName" placeholder="John Smith">
                <div [hidden]="isWarningHidden(form.get('accountProfile').get('contactName'))" class="alert alert-danger">
                  Contact Name is invalid
                </div>
                </fieldset>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <fieldset class="form-group">
                <label for="contact-title">
                  Title <span class="text-danger">*</span>
                </label>
                <input class="form-control" type="text" id="contact-title" formControlName="contactTitle" placeholder="CEO">
                <div [hidden]="isWarningHidden(form.get('accountProfile').get('contactTitle'))" class="alert alert-danger">
                  You must enter a title for this contact
                </div>
              </fieldset>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <fieldset class="form-group">
                <label for="contact-email">
                  Email <span class="text-danger">*</span>
                </label>
                <input class="form-control" type="text" id="contact-email" formControlName="contactEmail" placeholder="john@example.com">
                <div [hidden]="isWarningHidden(form.get('accountProfile').get('contactEmail'))" class="alert alert-danger">
                  Contact email is invalid
                </div>
              </fieldset>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <fieldset class="form-group">
                <label for="referenceDetails" class="small-top-buffer">
                  How did you hear about us? <span class="text-danger">*</span>
                </label>
                <input
                  id="referenceDetails"
                  type="text"
                  formControlName="referenceDetails"
                  placeholder="Please specify how you heard about us"
                  class="form-control">
                  <div [hidden]="isWarningHidden(form.get('accountProfile').get('referenceDetails'))" class="alert alert-danger">
                    This field is required
                  </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <fieldset class="form-group">
              <input type="submit" class="btn btn-lg float-right" [class.hot-orange-button]="!hasSetupAccountProfile()" [class.blue-button]="hasSetupAccountProfile()" value="{{hasSetupAccountProfile() ? 'Update Info' : 'Submit & continue'}}">
            </fieldset>
          </div>
        </div>
      </form>
    </div>
  </div>
</split-view>